if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      
     
      var text = jQuery(".dropdown-selector.dropdown-selector-default .dropdown-button-gsw__value").text().trim();
      var fText = text.replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, '');
      if(fText){
        flkty.destroy();
        flktyB.destroy();
        jQuery('.cls-all-img').attr('style', 'display: none !important'); //cls-current-
        jQuery(".cls-all-img.clshideshow-"+fText).attr('style', 'display: block !important');
        
        var elem = document.querySelector('.carousel.product__image-slider');
        flkty = new Flickity( elem, {
          cellSelector: '.product__media-item1:not([style*="display: none"])', 
          contain: true,
          imagesLoaded: true,
          lazyLoad: 1,
          wrapAround: true,
          pageDots: false,
          adaptiveHeight: true
        });
  
       
  
        var elemThumbnail = document.querySelector('.carousel.product__image-thumbnail');
          flktyB = new Flickity( elemThumbnail, {
          cellSelector: '.prod-thumb-image:not([style*="display: none"])', 
          asNavFor: '.carousel.product__image-slider',
          contain: true,
          imagesLoaded: true,
          lazyLoad: 4,
          pageDots: false,
          prevNextButtons: false
        });
        flkty.select(curZoomMediaId);
      }
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  });
}
